import React from 'react'
import ProductCard from '../../common/cards/ProductCard';
import { INewArrivalsAPIResponseDataEntity } from '@/src/types/newArrivals';
import EmptyState from '../../common/EmptyState';

interface CategoryProductProps {
  products: INewArrivalsAPIResponseDataEntity[];
}
export default function CategoryProduct({ products }: CategoryProductProps) {
  if (!products || products.length === 0) {
    return <EmptyState title="No products found" description="Try adjusting your filters or search to find what you're looking for." />;
  }

  return (
    <>
      <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4'>
        {products && products?.length > 0 && products?.map((product) => (
          <div key={product?._id}>
            <ProductCard data={product} />
          </div>
        ))}
      </div>
    </>
  )
}
